var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbsoluteReturnsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833496,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "url(#paint0_linear_393_22505)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833496,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "url(#paint1_linear_393_22505)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1891 11.4304C15.7138 11.1193 17.6844 9.95079 20.4765 10.0016C28.7247 10.1514 33.08 19.4618 28.4361 25.8554L29.8058 26.7682L25.9132 27.2257L26.3763 23.293L27.1123 24.4759C29.603 20.7278 28.6085 15.4122 24.393 12.9833C20.2232 10.5806 16.5984 12.7657 16.0664 13.0864C16.0283 13.1093 16.0061 13.1227 16.0006 13.1242L15.0615 11.5028C15.0809 11.4946 15.1238 11.4691 15.1891 11.4304ZM26.7883 25.138L26.6264 26.5131L28.0462 26.3463L27.5349 26.0055L27.7409 25.7405C29.022 24.1015 29.7145 22.0799 29.7073 20.0004C29.7073 12.8884 22.0922 8.42586 15.9182 11.7348L16.2313 12.2757C21.9838 9.21073 29.0823 13.3739 29.0823 20.0004C29.0882 21.8852 28.4787 23.7205 27.3461 25.2278L27.072 25.5939L26.7883 25.138Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.555 15.5248C11.0643 19.2728 12.0588 24.5884 16.2743 27.0174C20.4442 29.4201 24.0689 27.235 24.6009 26.9143C24.6389 26.8914 24.6612 26.878 24.6667 26.8765L25.6058 28.4979L25.3353 28.6543C18.7426 32.4661 10.335 27.7408 10.335 20.0003C10.3276 17.8968 10.9919 15.8458 12.2312 14.1454L10.8615 13.2327L14.7541 12.7749L14.291 16.7077L13.555 15.5248ZM13.0359 14.121C12.6088 14.652 10.96 16.7014 10.96 20.0003C10.96 27.1123 18.5749 31.5747 24.7493 28.2658L24.436 27.725C18.6835 30.7899 11.585 26.6268 11.585 20.0003C11.585 17.0176 13.0448 15.1275 13.4801 14.5638C13.5402 14.486 13.5808 14.4335 13.5953 14.4068L13.879 14.8627L14.0409 13.4875L12.621 13.6544L13.1324 13.9952C13.1218 14.0143 13.0879 14.0565 13.0359 14.121Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6475 19.3757H20.0225C19.9396 19.3757 19.8601 19.3428 19.8015 19.2842C19.7429 19.2257 19.71 19.1463 19.71 19.0634C19.71 18.9806 19.7429 18.9012 19.8015 18.8427C19.8601 18.7841 19.9396 18.7512 20.0225 18.7512H21.2725V18.1268H20.6475V17.5023H20.0225V18.1268C19.7738 18.1268 19.5354 18.2254 19.3595 18.4011C19.1837 18.5768 19.085 18.815 19.085 19.0634C19.085 19.3119 19.1837 19.5501 19.3595 19.7258C19.5354 19.9015 19.7738 20.0001 20.0225 20.0001H20.6475C20.7303 20.0001 20.8098 20.033 20.8684 20.0916C20.927 20.1501 20.96 20.2296 20.96 20.3124C20.96 20.3952 20.927 20.4746 20.8684 20.5331C20.8098 20.5917 20.7303 20.6246 20.6475 20.6246H19.3975V21.2491H20.0225V21.8735H20.6475V21.2491C20.8961 21.2491 21.1346 21.1504 21.3104 20.9747C21.4862 20.799 21.585 20.5608 21.585 20.3124C21.585 20.0639 21.4862 19.8257 21.3104 19.65C21.1346 19.4744 20.8961 19.3757 20.6475 19.3757Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.21 19.3757H22.835V20.0001H22.21V19.3757Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.46 19.3757H17.835V20.0001H18.46V19.3757Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7767 16.437C25.8939 16.5541 25.9598 16.7128 25.96 16.8784V22.4985C25.9598 22.6641 25.8939 22.8228 25.7767 22.9399C25.6595 23.0569 25.5007 23.1228 25.335 23.123H21.7588L19.2301 25.6495C19.1128 25.7664 18.9539 25.8321 18.7882 25.8321C18.6225 25.8321 18.4635 25.7664 18.3462 25.6495L15.8175 23.123H15.335C15.1693 23.1228 15.0104 23.0569 14.8932 22.9399C14.7761 22.8228 14.7102 22.6641 14.71 22.4985V16.8784C14.7102 16.7128 14.7761 16.5541 14.8932 16.437C15.0104 16.32 15.1693 16.2541 15.335 16.2539H18.9111L21.4398 13.7274C21.5571 13.6105 21.716 13.5448 21.8818 13.5448C22.0475 13.5448 22.2064 13.6105 22.3237 13.7274L24.8524 16.2539H25.335C25.5007 16.2541 25.6595 16.32 25.7767 16.437ZM24.5431 17.6696C24.7597 17.886 25.035 18.0343 25.335 18.0961V16.8784H24.1164C24.1782 17.1781 24.3265 17.4532 24.5431 17.6696ZM23.9686 16.2539L21.8818 14.169L19.795 16.2539H23.9686ZM16.1269 17.6697C16.3435 17.4532 16.4919 17.1782 16.5537 16.8784H15.335V18.0961C15.635 18.0343 15.9103 17.8861 16.1269 17.6697ZM16.1269 21.7074C15.9103 21.491 15.635 21.3428 15.335 21.281V22.4985H16.5537C16.4919 22.1988 16.3435 21.9238 16.1269 21.7074ZM16.7014 23.123L18.7881 25.2079L20.8749 23.123H16.7014ZM16.5683 21.2663C16.902 21.5997 17.1191 22.0319 17.1873 22.4985H23.4827C23.5508 22.0319 23.7679 21.5997 24.1016 21.2663C24.4354 20.9328 24.8679 20.7159 25.335 20.6478V18.7291C24.8679 18.661 24.4354 18.4441 24.1017 18.1106C23.7679 17.7772 23.5508 17.345 23.4827 16.8784H17.1873C17.1191 17.345 16.902 17.7772 16.5683 18.1106C16.2345 18.4441 15.802 18.661 15.335 18.7291V20.6478C15.802 20.7159 16.2345 20.9328 16.5683 21.2663ZM24.1164 22.4985H25.335L25.3352 21.2808C25.0351 21.3426 24.7598 21.4908 24.5432 21.7072C24.3266 21.9237 24.1782 22.1988 24.1164 22.4985Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_22505",
    x1: 20.3335,
    y1: 0,
    x2: 20.3335,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BB390"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_393_22505",
    x1: 74.0215,
    y1: -43.8409,
    x2: -18.871,
    y2: 9.78395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbsoluteReturnsIcon);
export default __webpack_public_path__ + "static/media/absolute_returns_icon.0c1689264b2e0c48ce4d9071c77dbd1f.svg";
export { ForwardRef as ReactComponent };